import store from 'store'

let db = {
  save (key, value) {
    store.set(key, value)
  },
  get (key, defaultValue) {
    return store.get(key, defaultValue)
  },
  remove (key) {
    store.remove(key)
  },
  clear () {
    store.clearAll()
  }
}

export default db
